import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TofuWorkspace } from "types/generated";

const StackWorkspacesNameCell = ({
  item: workspace,
  ...cellProps
}: TableSimpleCellProps<TofuWorkspace>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{workspace.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default StackWorkspacesNameCell;
